import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { SiteMode } from '@classes/site-mode';
import { SiteModeService } from 'app/core/services/site-mode.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-site-mode-list',
  templateUrl: './site-mode-list.component.html',
  styleUrls: ['./site-mode-list.component.scss']
})
export class SiteModeListComponent implements OnInit {

  @Input() set control(ctr: FormControl | null) {
    if (ctr) {
      this.myControl = ctr;
      this._initFilteredSiteModes();
    }
  }
  @Input() placeHolder: string;

  myControl!: FormControl;

  siteModes: SiteMode[] = [];
  filteredSiteModes: Observable<SiteMode[]> | undefined;

  constructor(
    public siteModeService: SiteModeService
  ) {
    this._initList();
  }

  ngOnInit() {
  }

  private _initList() {
    this.siteModeService.getSiteModes().subscribe(siteModes => {
      this.siteModes = siteModes
      .sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));;
      this._initFilteredSiteModes();
    }, error => {
      console.error(error);
    })
  }

  private _initFilteredSiteModes(): void {
    if (this.myControl) {
      this.filteredSiteModes = this.myControl.valueChanges
        .pipe(
          startWith(''),
          map(value => {
            if (typeof value === 'string') {
              return this._filter(value);
            }
            return [];
          })
        );
    }
  }

  private _filter(value: string): SiteMode[] {
    const filterValue = value.toLowerCase();
    return this.siteModes.filter(option => (option.name || '').toLowerCase().includes(filterValue));
  }

  displayFn(siteMode?: SiteMode): string {
    return siteMode ? (siteMode.name || '') : '';
  }
}
